import React from "react";
import { useAuth } from "../../../context/API_Client";
import HoverToDisplayFullTitle from "../../../reusableComponents/HoverToDisplayFullTitle";
import MoreOptionsForTable from "../moreOptionsForTable";
import { sortDateTime } from "../../utils/utils";
import UserProfileIcon from "../../../../assets/svg/user-profile.svg";
import { colorBrandObject } from "../../../../constants/brandings";
import { iconDefaultColor } from "../../../reusableComponents/constants";

const RoleSchema = (
  deleteRoleData,
  editRoleData,
  actionValue,
  operationPermissions
) => {
  const { isAuthorizedPermission } = useAuth();

  const handleActionData = (value) => {
    editRoleData(value);
    deleteRoleData(value);
  };

  const handleActionValue = (value) => {
    actionValue(value);
  };

  const schema = {
    metadata: {
      title: "Roles",
      minHeight: 600,
      position: "relative",
      showTitle: false,
      rowHeight: 65,
      defaultSortInfo: { name: "createdOn", dir: -1 },
    },
    fields: [
      {
        name: "name",
        header: "Role",
        visible: true,
        type: "string",
        filtering: false,
        sortable: false,
        minWidth: 250,
        defaultFlex: 1,
        textAlign: "center",
        render: ({ data }) => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  marginLeft: "-12px",
                  maxWidth: "550px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <HoverToDisplayFullTitle title={data?.name} len={24} />
                {data?.orgId === null && (
                  <span
                    style={{
                      marginLeft: "10px",
                      borderRadius: "8px",
                      background: "var(--Base-Tokens-Slate-8, #F4F4F4)",
                      padding: "2px 16px",
                    }}
                  >
                    <span fill={{ stroke: iconDefaultColor }}>
                      <UserProfileIcon fill={`${colorBrandObject?.primaryButtonColor}`} />
                    </span>
                    <span
                      style={{
                        color: "var(--Global-Purple-900, #403E9F)",
                        marginLeft: "4px",
                      }}
                    >
                      Default
                    </span>
                  </span>
                )}
              </span>
            </div>
          );
        },
      },
      {
        name: "description",
        header: "Description",
        visible: true,
        type: "string",
        filtering: false,
        sortable: false,
        minWidth: 350,
        defaultFlex: 1,
        textAlign: "center",
        render: ({ value }) => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  marginLeft: "-12px",
                  maxWidth: "550px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <HoverToDisplayFullTitle title={value} len={30} />
              </span>
            </div>
          );
        },
      },
      {
        name: "assignedUsers",
        header: "Number of users",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 200,
        defaultFlex: 1,
        render: ({ value }) => {
          let backgroundColor = "var(--global-purple-400, #E4E3FF)";
          let color = "var(--global-neutral-grey-1200, #1D1C20)";
          return (
            <span
              style={{
                marginLeft: "-10px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                backgroundColor,
                color,
                fontFamily: "Poppins",
              }}
            >
              {value?.length}
            </span>
          );
        },
      },
      {
        name: "createdOn",
        header: "Created At",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 250,
        defaultFlex: 1,
        sort: sortDateTime,
        render: ({ value }) => {
          return (
            <span
              style={{
                marginLeft: "-15px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                fontFamily: "Poppins",
              }}
            >
              {value}
            </span>
          );
        },
      },
      {
        name: "id",
        header: "Actions",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 100,
        defaultFlex: 1,
        textAlign: "center",
        sortable: false,
        render: (data) => (
          <>
            <MoreOptionsForTable
              options={["Edit Role", "Delete Role"]}
              data={data?.data}
              handleActionValue={handleActionValue}
              handleActionData={handleActionData}
              disableDelete={true}
              dataForRole={true}
              operationPermissions={operationPermissions}
            />
          </>
        ),
      },
    ],
  };
  return schema;
};

export default RoleSchema;
